/**
 * ehr#437 (CLINICAL_NOTES_TAB_10-14-V15): the kinds of chart note (now in @ehr/shared/noteKinds,
 * which the API reads too), and what the "What kind of note?" window offers today.
 */
import { NOTE_TYPE_GROUPS, noteTypeOf } from '@ehr/shared';

export {
  NOTE_TYPE_GROUPS,
  isNoBillingKind,
  noteTypeOf,
  type NoteTypeGroup,
  type NoteTypeItem,
} from '@ehr/shared';

/**
 * The kinds that open a note today. Taras (ehr#437): the rest stay greyed until their note is
 * built. Group is never started here: it starts from the group appointment, roster filled.
 * Part 3: the Other notes open on their layouts (CASE_MANAGEMENT_NOTES_10-14-V25).
 */
export const NOTE_TYPES_READY: readonly string[] = [
  'Individual',
  'Crisis',
  // FAMILY_COUPLES_NOTE_10-14-V15: a family or couples session, one note per attendee
  'Family',
  'Couples',
  ...NOTE_TYPE_GROUPS.find((g) => g.group === 'Other notes')!.items.map((i) => i.type),
];

/** Why a greyed tile can't be picked, shown when it's clicked. */
export function noteTypeOffReason(type: string): string {
  if (type === 'Group')
    // ehr#479: + Add new lists the client's group sessions too
    return 'A group note starts from the group appointment, so the roster is already filled: pick the session tagged Group in the appointment list (Cancel, then + Add new), or open it from Calendar or Today’s Schedule.';
  return `The ${type} note isn’t built yet. It will open here once it is.`;
}

/**
 * ehr#527: the session type a new note starts on, from the practice's appointment types: the
 * appointment's own type when the practice has it; else the first type of the picked kind, by
 * name first ("Individual Therapy" for Individual), then by what the name means (noteTypeOf);
 * else the kind's own name. It never lands on another kind's type ("New Client" for Individual).
 */
export function startSessionType(kind: string, types: readonly string[], apptLabel = ''): string {
  const want = apptLabel.trim().toLowerCase();
  const own = want ? types.find((t) => t.toLowerCase() === want) : undefined;
  if (own) return own;
  const k = kind.toLowerCase();
  const named = types.find(
    (t) => t.toLowerCase().includes(k) && noteTypeOf({ sessionLabel: t }) === kind,
  );
  return named ?? types.find((t) => noteTypeOf({ sessionLabel: t }) === kind) ?? kind;
}
